<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/results_sub.jpg" />
      <h1 class="">実績確認</h1>
    </div>
    <div class="tt">
      <div class="rank_id d-flex align-items-center column_sp mt-5">
        <div class="mr-2">会員番号</div>
        <input
          v-model="memberNo"
          class="my-3"
          name="input"
          type="text"
          style="ime-mode: disabled"
          maxlength="10"
        />
        <div class="d-flex align-items-center">
          <button
            type="button"
            @click="numberSearch"
            name="input btn"
            align="middle"
            class="ml-3"
          >
            検索する
          </button>
          <button
            type="button"
            @click="myResult"
            name="input btn"
            align="middle"
            class="ml-2 mr-3"
          >
            自分の実績を表示
          </button>
        </div>
      </div>

      <dl class="rank mt-5 mb-3">
        <dt>月初ランク</dt>
        <dd id="RankNameFirst">{{ rankNameFirst }}</dd>
        <dt>現在ランク</dt>
        <dd id="RankNamePrice">{{ rankNamePrice }}</dd>
        <dt>自己購入実績数(前月)</dt>
        <dd id="numPrevious">{{ numPrevious }}</dd>
        <dt>自己購入実績数(今月)</dt>
        <dd id="numCurrent">{{ numCurrent }}</dd>
      </dl>
      <!-- ここからサーバからhtmlを返している部分 -->
      <div id="ResultBlock">
        <div class="FavoriteDiv">
          <dl v-show="isManager" class="rank">
            <dt>全体G人数V除</dt>
            <dd>{{ subV }}</dd>
          </dl>
          <dl v-show="isJM" class="rank">
            <dt>全体G人数</dt>
            <dd>{{ subV }}</dd>
            <dt>全体G人数J除</dt>
            <dd>{{ subJ }}</dd>
          </dl>
          <dl v-show="isOther" class="rank">
            <dt>全体G人数</dt>
            <dd>{{ subAll }}</dd>
          </dl>
        </div>

        <div class="tab-wrap my-5">
          <input
            id="TAB-01"
            type="radio"
            name="TAB"
            class="tab-switch"
            v-model="selectTab"
            value="t1"
          /><label class="tab-label" v-if="!isV" for="TAB-01">{{
            t1Label
          }}</label>
          <div class="tab-content">
            <div class="graph_people w-100">
              <canvas id="T1"></canvas>
            </div>
          </div>
          <input id="TAB-02" type="radio" name="TAB" class="tab-switch" /><label
            class="tab-label"
            for="TAB-02"
            v-if="!isV"
            >{{ t2Label }}</label
          >
          <div class="tab-content">
            <div class="graph_quantity w-100">
              <canvas id="T2"></canvas>
            </div>
          </div>
          <input
            id="TAB-03"
            type="radio"
            name="TAB"
            class="tab-switch"
            v-model="selectTab"
            value="t3"
          /><label
            class="tab-label"
            for="TAB-03"
            v-if="isManager || isJM || isV"
            >{{ t3Label }}</label
          >
          <div class="tab-content">
            <div class="graph_people w-100">
              <canvas id="T3"></canvas>
            </div>
          </div>
          <input id="TAB-04" type="radio" name="TAB" class="tab-switch" /><label
            class="tab-label"
            for="TAB-04"
            v-if="isManager || isJM || isV"
            >{{ t4Label }}</label
          >
          <div class="tab-content">
            <div class="graph_quantity w-100">
              <canvas id="T4"></canvas>
            </div>
          </div>
          <input id="TAB-05" type="radio" name="TAB" class="tab-switch" /><label
            v-if="isManager"
            class="tab-label"
            for="TAB-05"
            >半期購入実績数</label
          >
          <div class="tab-content">
            <div class="w-100">
              <h2 class="text-left border-bottom mb-3">半期購入実績数</h2>
              <h3>
                半期G実績数（V除）: {{ harfPeriodGroupBuyCount.GroupSales }}
              </h3>
              <h3>
                半期G返品実績数（V除）:{{ harfPeriodGroupBuyCount.GroupReturns }}
              </h3>
              <h3>半期G実績数（V除）:{{ harfPeriodGroupBuyCount.Total }}</h3>
            </div>
          </div>
          <input
            id="TAB-06"
            type="radio"
            name="TAB"
            class="tab-switch"
            v-model="selectTab"
            value="tree"
          /><label class="tab-label" for="TAB-06"
            >組織図</label
          >
          <div class="tab-content tab-tree">
            <div id="Organization">
              <div class="tree-search">
                会員番号
                <input v-model="treeSearchNo" type="number" />
                <button
                  type="button"
                  @click="treeSearch"
                  name="input btn"
                  align="middle"
                  class="ml-3"
                >
                  Go
                </button>
              </div>
              
              <div class="tree_info d-flex">
          <div>
            <label class="label_yellow">前・当年度の実績数3未満</label><br>
            <span style="margin-left: 40px;">（前・当年度入会は対象外）</span>
          </div>
          <div>
            <label class="label_orange">当年度の購入なし</label>
          </div>
          <div>
            <label class="label_green" style="padding-left: 45px">入会後30日以内</label>
          </div>
          <div>
            <label class="label_star">ショッピング会員</label>
          </div>
        </div>
              <div class="tree_group w-100" ref="tree" id="tree">
                <ul>
                  <li v-for="item in tree" :key="item.Member">
                    <treeItem :tree="item" :fullOpen="fullOpentogle"></treeItem>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Request from "@/modules/Request";
import treeItem from "./components/treeItem";
import Message from "@/modules/Message";
let request = new Request();
import Chart from "chart.js/auto";
import Device from "@/modules/Device";
let device = new Device();
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  components: {
    treeItem,
  },
  data() {
    return {
      memberNo: "", // 会員番号

      // 実績一行目
      rankNameFirst: "", // 月初ランク
      rankNamePrice: "", // 現在ランク
      numPrevious: "", // 自己購入数量（前月）
      numCurrent: "", // 自己購入数量（今月）
      // 実績２行目
      isManager: false,
      isJM: false,
      isOther: false,
      isV: false,
      canTreeView: false,
      subV: 0,
      subJ: 0,
      subAll: 0,
      harfPeriodGroupBuyCount: [],

      contents: [],
      charts: [],
      treeContainer: "",
      tree: [],
      treeSearchNo: "",
      fullOpentogle: true,
      t1Label: "G人数",
      t2Label: "G実績数",
      t3Label: "G人数(J除)",
      t4Label: "G実績数(J除)",
      selectTab: "t1",
    };
  },
  mounted() {
    this.myResult();
    window.scroll(0, 0);
  },
  methods: {
    treeSearch() {
      let mes;
      this.treeSearchNo == ""
        ? (mes = "会員番号が未入力です。")
        : (mes = "会員番号が一致しません。");
      if (!document.getElementById(this.treeSearchNo)) {
        Message.error().fire({
          title: mes,
        });
        return;
      }

      this.fullOpentogle
        ? (this.fullOpentogle = false)
        : (this.fullOpentogle = true);
      this.$nextTick(function () {
        let target = document.getElementById(this.treeSearchNo);
        let target2 = document.getElementById("tree");
        var rect = target.getBoundingClientRect();
        var rect2 = target2.getBoundingClientRect();
        var elemtop = rect.top - rect2.top;
        target2.scrollTop += elemtop;
        this.$store.state.treeIsClickMember = this.treeSearchNo;
      });
    },
    drowChart(canvas) {
      var ctx = document.getElementById(canvas).getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var contents1 = this.contents[canvas][0];
      var contents2 = this.contents[canvas][1];
      var lavels = [];
      var data1 = [];
      var data2 = [];
      contents1.forEach((content) => {
        lavels.push(content[0]);
        data1.push(content[1]);
      });
      contents2.forEach((content) => {
        data2.push(content[1]);
      });
      var title;

      switch (canvas) {
        case "T1":
          title = "グループ人数";
          break;
        case "T2":
          title = "グループ実績数";
          break;
        case "T3":
          if (this.isV || this.isManager) {
            title = "グループ人数(V除)";
            this.t3Label = "G人数(V除)";
          } else {
            title = "グループ人数(J除)";
            this.t3Label = "G人数(J除)";
          }
          break;
        case "T4":
          if (this.isV || this.isManager) {
            title = "グループ実績数(V除)";
            this.t4Label = "G実績数(V除)";
          } else {
            title = "グループ実績数(J除)";
            this.t4Label = "G実績数(J除)";
          }
          break;
      }

      var options;
      var options1 = {
        plugins: {
          title: {
            display: true, // タイトルを表示する
            text: title, // タイトルのテキスト
          },
          datalabels: {
            anchor: "end",
            align: "top",
            font: {
              weight: "bold",
            },
          },
        },
      };
      var options2 = {
        plugins: {
          title: {
            display: true, // タイトルを表示する
            text: title, // タイトルのテキスト
          },
          datalabels: {
            anchor: "end",
            align: "top",
            font: {
              weight: "bold",
            },
          },
        },
        indexAxis: "y",
        aspectRatio:0.5
      };
      if(device.isMobile()){
        options = options2;
      }else{
        options = options1;
      }
      this.charts.push(
        new Chart(ctx, {
          plugins: [ChartDataLabels],
          type: "bar",
          data: {
            labels: lavels,
            datasets: [
              {
                label: "前年度",
                data: data1,
                backgroundColor: "rgba(255, 159, 64, 0.7)",
              },
              {
                label: "当年度",
                data: data2,
                backgroundColor: "rgba(75, 192, 192, 0.7)",
              },
            ],
          },
          options: options,
        })
      );
    },
    numberSearch() {
      this.getResult(this.memberNo);
    },
    myResult() {
      this.getResult();
    },
    getResult(memberNo) {
      let postParams = [memberNo];
      let requestParams = request.createParams(
        "webMdlResult",
        "getResults",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.memberNo = data.memberNo;
          this.rankNameFirst = data.rankNameFirst;
          this.rankNamePrice = data.rankNamePrice;
          this.numPrevious = data.numPrevious;
          this.numCurrent = data.numCurrent;

          this.isManager = data.isManager;
          this.isJM = data.isJM;
          this.isOther = data.isOther;
          this.isV = data.isV;
          this.canTreeView = data.canTreeView;
          this.subV = data.subV;
          this.subJ = data.subJ;
          this.subAll = data.subAll;
          this.tree[0] = data.TVContents;
          this.treeContainer = data.TreeviewContainer;
          this.harfPeriodGroupBuyCount = data.harfPeriodGroupBuyCount;

          // テスト用  FUE
          // this.isManager = false;
          // this.isV = false;
          // this.isJM = false;

          // JM
          // this.isManager = false;
          // this.isV = false;
          // this.isJM = true;

          // V
          // this.isManager = false;
          // this.isV = true;
          // this.isJM = false;

          //マネージャー
          // this.isManager = true;
          // this.isV = false;
          // this.isJM = false;

          // ツリービュー
          // this.canTreeView = false;

          //タブの初期選択
          if (this.$route.params.tab) {
            this.selectTab = "tree";
          } else if (this.isV) this.selectTab = "t3";

          //グラフ初期化
          if (this.charts) {
            this.charts.forEach((chart) => {
              chart.destroy();
            });
          }

          //グラフ用データ
          if (data.t1Contents) {
            this.contents["T1"] = data.t1Contents[0];
            this.drowChart("T1");
          }
          if (data.t2Contents) {
            this.contents["T2"] = data.t2Contents[0];
            this.drowChart("T2");
          }
          if (data.t3Contents) {
            this.contents["T3"] = data.t3Contents[0];
            this.drowChart("T3");
          }
          if (data.t4Contents) {
            this.contents["T4"] = data.t4Contents[0];
            this.drowChart("T4");
          }
        });
    },
  },
};
</script>

<style scoped>
#tree {
  overflow-y: auto;
  height: 800px;
  margin-top: 1em;
}
dl.rank {
  display: flex;
  display: -ms-flexbox;
  align-items: center;
}
dl.rank dt,
dl.rank dd {
  padding: 10px 15px;
  border: 1px solid #ccc;
}
dl.rank dt {
  background: #e4e4e4;
}
dl.rank dd {
  font-weight: bold;
}
dl.rank {
  width: max-content;
}
/* タブ */
.tab-wrap {
  display: flex;
  flex-wrap: wrap;
}
.tab-label {
  background: #fff;
  margin-right: 5px;
  margin-bottom: -1px;
  padding: 10px 15px;
  order: -1;
  border: 1px solid #ccc;
}
.tab-label:hover {
  cursor: pointer;
  background: #fafafa;
}
.tab-content {
  width: 100%;
  display: none;
  padding: 20px;
  border-top: 3px solid #e4e4e4;
  box-shadow: 1px 1px 5px #e4e4e4;
}
/* アクティブなタブ */
.tab-switch:checked + .tab-label {
  background: #e4e4e4;
}
.tab-switch:checked + .tab-label + .tab-content {
  display: block;
}
/* ラジオボタン非表示 */
.tab-switch {
  display: none;
}

@media screen and (min-width: 1px) and (max-width: 991px) {
  dl.rank {
    flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    width: 100%;
  }
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  dl.rank dt {
    width: 190px;
    border-bottom: 1px solid #ccc;
  }
  dl.rank dd {
    width: calc(100% - 190px);
  }
  dl.rank dt,
  dl.rank dd {
    margin-bottom: 3px;
  }
  .tab-label {
    width: 47%;
    margin-left: 5px;
    margin-bottom: 5px;
  }
  .tab-wrap {
    justify-content: center;
  }
  .tab-content {
    border-top: none;
    margin-top: 1em;
  }
  .tab-content.tab-tree {
    padding: 20px 5px;
  }
  #tree {
    height: 600px;
  }
}
@media screen and (min-width: 1px) and (max-width: 498px) {
  .tree-search {
    text-align: center;
  }
  .tree-search button {
    margin-top: 10px;
  }
}
</style>